<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
  @font-face {
    font-family: 'latoFont';
    src: url('static/font/Lato-Regular.ttf');
  }
</style>
